import React from 'react'
import classnames from 'classnames'

import {Button, LinkButton} from '../../../ui/components'
import {TNavigation} from '../../types'

import styles from './styles.module.css'

type TSwitcherProps = {
  navigation: TNavigation[]
  activeLinkIndex: number
  className?: string
  type?: 'button' | 'link'
  onChangeTab?: (index: number) => void
}

export function Switcher({navigation, activeLinkIndex, className, type = 'button', onChangeTab}: TSwitcherProps) {
  return (
    <nav className={classnames(styles.switcher, className)}>
      {navigation.map(({label, link}, index) => {
        const variant = activeLinkIndex === index ? 'primary' : 'secondary'

        if (type === 'button') {
          return (
            <Button key={index.toString()} variant={variant} size="m" shape="boxy" onClick={() => onChangeTab?.(index)}>
              {label}
            </Button>
          )
        }

        return (
          <LinkButton href={link} key={index.toString()} variant={variant} size="l" shape="boxy">
            {label}
          </LinkButton>
        )
      })}
    </nav>
  )
}
